<template>
  <v-main class="bg-background" scrollable>
    <div
      :class="{ 'pa-4': !noPadding }"
      class="h-100"
      data-testid="so-page-with-right-side-panel"
    >
      <slot></slot>
    </div>
  </v-main>
  <v-navigation-drawer
    :rail="value"
    permanent
    floating
    elevation="4"
    location="right"
    :rail-width="sidebarWidth"
    width="350"
    data-testid="so-page-with-right-side-panel-side-panel"
  >
    <v-list-item nav>
      <SoButton
        data-testid="so-page-with-right-side-panel-toggle"
        type="icon"
        class="mt-1"
        :icon="value ? 'arrow-expand-left' : 'arrow-expand-right'"
        @click="value = !value"
      ></SoButton>
    </v-list-item>
    <v-list-item>
      <slot v-if="value" name="sidePanelRail"></slot>
      <slot v-else name="sidePanel"></slot>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: { SoButton },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      noPadding: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "onClose"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      sidebarWidth() {
        return this.$vuetify.display.mobile ? 73 : 108
      },
    },
  })
</script>
